import { App, NavController, NavParams,LoadingController, ToastController } from 'ionic-angular';
//import { PostPicPage } from '../post-pic/post-pic';
import { ApiService } from '../../api-service/api-service';

import { Component, ViewChild } from '@angular/core';
import { Content } from 'ionic-angular';

import { User,UserPost,UserComment,UserData } from '../../providers/providers';

declare var AWS: any;
declare const aws_user_files_s3_bucket;
declare const aws_user_files_s3_bucket_region;

const url = 'https://cdn.chitika.net/getads.js';

@Component({
  templateUrl: 'comments-view.html'
})
export class CommentViewPage {

  items:UserComment[] = [];


  private s3: any;
  public sub: string = null;
  public lastKey: any = "";
  public IScroll:any;
  public commentMessage:string = "";
  private postId:string;

  loadAPI: Promise<any>;
  public placement_id:number;
  public bannerId:string = "not set";
  

  constructor(public navCtrl: NavController,public navParams:NavParams,public server:ApiService,
    public user:User,
    public toastCtrl: ToastController, public userData:UserData) {
      
        if (navParams.get('userPostId')){
            this.postId = navParams.get('userPostId');
        }

      this.s3 = new AWS.S3({
        'params': {
          'Bucket': aws_user_files_s3_bucket
        },
        'region': aws_user_files_s3_bucket_region
      });

      if (navParams.get('postId')){
        this.postId = navParams.get('postId');
      }

      this.sub = AWS.config.credentials.identityId;

      //  this.generateTestPosts();
      //TODO get comments
      this.getComments();
  }

  /* 2017-08-16 - add this to class body
    start FIX#9660 ion-img doesn't correctly work with virtualScroll
    https://github.com/ionic-team/ionic/issues/9660#issuecomment-304840427
*/
/*
@ViewChild(Content) _content: Content;
ngAfterViewInit() {
    if (this._content) {
        this._content.imgsUpdate = () => {
            if (this._content._scroll.initialized && this._content._imgs.length && this._content.isImgsUpdatable()) {
                // reset cached bounds
                this._content._imgs.forEach((img: Img) => (<any>img)._rect = null);
                // use global position to calculate if an img is in the viewable area
                updateImgs(this._content._imgs, this._content._cTop * -1, this._content.contentHeight, this._content.directionY, 1400, 400);
            }
        };
    }
}
*/
/*
end FIX#9660
*/

  addComments(commentId = null){
      if (this.commentMessage.length > 0)
      {
        let comment = new UserComment(this.postId);
        comment.Comment = this.commentMessage;
        let avatarKey = "protected/"+ this.sub + "/avatar";
        comment.AvatarKey = avatarKey;
        if(commentId){
            comment.ReplyToId = commentId;
        }

        //let testComment = new UserComment(postId,this.user.getUsername());
        this.server.postComment(comment, this.commentCallBack);
      }
  }

  //Fat arrow used to keep scope, private entry back in
  public commentCallBack = (comments) => {
    this.getComments();
  }

  getComments(){
    this.server.getComments(this.postId,this.lastKey,this.getCommentsCallback);
  }

  //Fat arrow used to keep scope, private entry back in
  public getCommentsCallback = (comments) => {
    this.loadCommentsfromCallback(comments);
  }


  loadCommentsfromCallback(comments){
    if(comments.LastEvaluatedKey){
        this.lastKey = comments.LastEvaluatedKey;
      }
      else
      {
        this.lastKey = "";
      }
    for (let i = 0; i < comments.Items.length; i++) {
        this.s3.getSignedUrl('getObject', {'Key': comments.Items[i].AvatarKey}, (err, avatarUrl) => {
            comments.Items[i].avatarURL = avatarUrl;
          this.items.push( comments.Items[i] );
        });
      };
       
       if(this.IScroll){
         this.IScroll.complete();
       }
       this.commentMessage = "";
    }
  
    voteForComment(Comment){
    //TODO implement comment voting 
    alert("Implement me"); 
    /*
      if(this.userData.votes > 0)
      {
        this.server.voteForPic(Post,this.voteForPostCallBack);
      }
      else
      {
        alert ("Out of Votes Try again later!");
      }
    */
    }

    public voteForCommentCallBack = (commentVotedOn:UserComment) => {
      this.updateVote(commentVotedOn);
    }

    updateVote(commentVotedOn:UserComment){
      commentVotedOn.Votes = commentVotedOn.Votes+1 
    }

    reply(commentId){
        alert("Implement Me");
    }


    
  doInfinite(infiniteScroll) {
    this.IScroll = infiniteScroll;
    console.log('Begin async operation');
    if (this.lastKey !== "")
    {
      this.server.getComments(this.postId,this.lastKey,this.commentCallBack);
    }
    else
    {
      infiniteScroll.complete();
    }
    /*setTimeout(() => {
      for (let i = 0; i < 30; i++) {
          let fakePost = new UserPost("Funny");
          fakePost.generateTestPost();
        this.items.push( fakePost );
      }

      console.log('Async operation has ended');
      infiniteScroll.complete();
    }, 500);
    */
  }

  chitikaAddHeight(){
    if (window['CHITIKA'] === undefined) { window['CHITIKA'] = { 'units' : [] }; };
          var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
          this.placement_id = window['CHITIKA'].units.length;
          window['CHITIKA'].units.push(unit);
          this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
          //document.write('<div id="chitikaAdBlock-' + this.placement_id + '"></div>');
  }

  ngAfterViewInit(){
    this.loadAPI = new Promise((resolve) => {
        console.log('resolving promise...');
        this.loadScript();
    }).catch((err)=>{
      let t = err;
      console.log(t);
    });
}



public loadScript() {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.chitikaAddHeight();
}

}



// WEBPACK FOOTER //
// ./src/pages/comments-view/comments-view.ts